<!-- =========================================================================================
  File Name: NewQuoteSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <vs-sidebar
   click-not-close
   position-right
   parent="body"
   default-index="1"
   color="primary"
   class="add-new-data-sidebar items-no-padding"
   spacer
   v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ !this.data.productToEdit ? "Adicionar" : "Editar" }} Produto</h4>
      <feather-icon
       icon="XIcon"
       @click.stop="isSidebarActiveLocal = false"
       class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-6">
        <h6 class="mb-2">Produto</h6>
        <v-select
         taggable
         v-model="newProduct"
         :filter="filterProducts"
         :options="products"
         :create-option="createOption"
         :getOptionLabel="option => option.codigo">
          <template v-slot:option="option">
            <h6 style="margin: 0">{{ option.codigo }}</h6>
            <span style="font-size: 12px;">{{ option.descricaoPTBR }}</span>
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              Nenhuma resultado encontrado para <em>{{ search }}</em>.
            </template>
            <em
             style="opacity: 0.5;"
             v-else>Nenhum resultado encontrado</em>
          </template>
        </v-select>
        <br>
        <transition-group name="fade" tag="div">
          <div key="div1" v-if="newProduct">
            <h6 class="mb-2">Descrição</h6>
            <vs-input name="descricaoPTBR" class="w-full" v-model="newProduct.descricaoPTBR"></vs-input>
            <br>
            <h6 class="mb-2">Marca</h6>
            <vs-input name="marca" class="w-full" v-model="newProduct.marca"></vs-input>
            <br>
            <h6 class="mb-2">Modelo</h6>
            <vs-input name="modelo" class="w-full" v-model="newProduct.modelo"></vs-input>
            <br>
            <h6 class="mb-2">Quantidade</h6>
            <vs-input type="tel" v-mask="'###########'" class="w-full" @input="updateValorTotal" v-model="newProduct.quantidade"></vs-input>
            <br>
            <h6 class="mb-2">Valor Unitario</h6>
            <vs-input class="w-full" refs="valorUnitario" @input="updateValorTotal" v-currency="currencyMaskOptions" v-model="newProduct.valorUnitario"></vs-input>
            <br>
            <h6 class="mb-2">Valor Total</h6>
            <vs-input class="w-full" ref="valorTotal" readOnly v-currency="currencyMaskOptions" v-model="newProduct.valorTotal"></vs-input>
          </div>
        </transition-group>
      </div>
    </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData()" v-if="!this.data.productToEdit" :disabled="!isFormValid">Salvar</vs-button>
      <vs-button class="mr-6" @click="closeSidebar()" v-else-if="this.data.productToEdit" :disabled="!isFormValid">Salvar</vs-button>
      <vs-button type="border" color="danger" @click="closeSidebar()">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { setValue } from 'vue-currency-input'
import Fuse from "fuse.js"
import helpers from "@/helpers";

export default {
  components: {
    VuePerfectScrollbar,
  },
  directives: helpers.directives,
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => []
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (!this.data.productToEdit) {
        this.initValues();
      } else {
        this.newProduct = _.cloneDeep(this.data.productToEdit)
      }
    }
  },
  data() {
    return {
      currencyMaskOptions: helpers.maskOptions.currency,
      newProduct: null,
      helpers: null,
      products: [],
      settings: {
        wheelSpeed: 0.2
      },
      createOption: (codigo) => ({
        codigo,
        descricaoPTBR: '',
        marca: '',
        modelo: '',
      })
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
  },
  methods: {
    isFormValid() {
      return this.newProduct && this.newProduct.codigo && this.newProduct.descricaoPTBR && this.newProduct.marca && this.newProduct.modelo && this.newProduct.quantidade && this.newProduct.valorUnitario
    },
    closeSidebar() {
      this.initValues()
      this.$emit("closeSidebar");
      this.$emit("productEdited");
    },
    updateValorTotal() {
      let quantidade = this.newProduct.quantidade
      let valorUnitario = this.newProduct.valorUnitario
      if (!quantidade || !valorUnitario) {
        this.newProduct.valorTotal = null
        return
      }
      valorUnitario = this.$parseCurrency(this.newProduct.valorUnitario, this.currencyMaskOptions)
      if (this.$refs.valorTotal) {
        const elValorTotal = this.$refs.valorTotal.$refs.vsinput
        setValue(elValorTotal, quantidade * valorUnitario)
      }
    },
    initValues() {
      this.newProduct = null
      this.data.productToEdit = null
      this.helpers = helpers
      this.products = _.cloneDeep(this.data.products)
    },
    filterProducts(options, search) {
      const fuse = new Fuse(options, {
        keys: ['codigo', 'descricaoPTBR'],
        shouldSort: true,
        threshold: 0.1,
        distance: 100,
      });
      let fuseSearch = []
      for (let item of fuse.search(search)) {
        fuseSearch.push(item.item)
      }
      return search.length ? fuseSearch : fuse.list;
    },
    async submitData() {
      if (!this.isFormValid()) {
        this.$vs.notify({
          title: 'Erro',
          text: 'Insira dados em todos os campos!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }

      if (this.data.productToEdit)
        Object.keys(this.data.productToEdit).forEach(key => {
          this.data.productToEdit[key] = this.newProduct[key]
        });

      this.$emit("closeSidebar");
      this.$emit("productAdded", this.newProduct);
      this.initValues();
    },
  },
};

</script>
<style
 lang="scss"
 scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>
